import { ListItem } from '@/common/components/SimpleSelector.tsx'

export const MARKETPLACE_BUSINESS_CATEGORIES = {
  SCHOOL: 'School',
  TEACHER: 'Teacher',
  SHOP: 'Shop',
} as const

export const TABLE_FILTERS = [
  { id: 0, name: 'all_types' },
  { id: 1, name: MARKETPLACE_BUSINESS_CATEGORIES.SCHOOL },
  { id: 3, name: MARKETPLACE_BUSINESS_CATEGORIES.TEACHER },
  { id: 4, name: MARKETPLACE_BUSINESS_CATEGORIES.SHOP },
] as ListItem[]

export const MARKETPLACE_AVAILABILITY_FILTERS = [
  { id: 0, name: 'all_availability' },
  { id: 1, name: 'accepting_new_clients' },
  { id: 2, name: 'not_accepting_new_clients' },
] as ListItem[]
